export default __webpack_public_path__ + "static/media/football-active.23c0138b.webp";